import { Task, SubTask } from '@/renderer/scripts/utils/TaskManager/types';
import { FileInfo } from '@/renderer/scripts/utils/upload/types';
import { DownloadFileInfo } from '@/renderer/scripts/utils/download/types';

export type TaskId = string;

export type LocalTask = Task<any>;

export enum TableName {
  uploadTable = 'uploadTable',
  downloadTable = 'downloadTable',
}

export type UserInfo = { userId: number; orgId: number };

export { Task, TaskStatus, TaskEvents } from '@/renderer/scripts/utils/TaskManager/types';

export { FileInfo } from '@/renderer/scripts/utils/upload/types';
export { DownloadFileInfo } from '@/renderer/scripts/utils/download/types';

export type TransUploadTask = Task<FileInfo>;
export type TransDownloadTask = Task<DownloadFileInfo>;
export type TransSubTask = SubTask<FileInfo> | SubTask<DownloadFileInfo>;

export type TaskInDB = {
  taskId: TaskId;
  userId: number;
  orgId: number;
  taskInfo: TransUploadTask | TransDownloadTask;
};

export enum TaskType {
  upload = 'upload',
  download = 'download',
}
